export default __webpack_public_path__ + "efea39ada12ecaf823e6a52622863a37.png";